// Navigation intent, decoupled from any hosting implementation.
// Shared, reusable "related entity" components must depend only on this file.
export interface INavigationEntityRequest {
    entityType: 'asset' | 'project' | 'company' | 'contract',
    id: number,
    name: string,
    caption?: string
}

// Implemented by whichever component currently hosts entity flyouts
// (AssetSearchComponent, InformationRetrievalAgentPageComponent, future hosts).
// Angular's hierarchical injector resolves which concrete host a given
// descendant component receives — this contract itself knows no state names,
// no drawer/panel mechanics, and no host identities.
export abstract class EntityNavigationHost {
    abstract openEntity(request: INavigationEntityRequest): void;
}
